<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pfte3i/tc-custom/9781504045483.jpg?1734202244994" alt="This image is the cover for the book Americana Series Volume One, The Americana Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Americana Series Volume One, The Americana Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Three love stories set against great American landscapes in an acclaimed series by a <i>New York Times–</i>bestselling author and “romance legend” (<i>Publishers Weekly</i>). </b><br/><br/> With more than 300 million books sold, Janet Dailey is an icon of American fiction. In a romantic tour of the United States<b>, </b>the first lady of romance wrote fifty novels, one set in each state. The three enchanting installments of the Americana Series included in this collection tell heart-soaring tales of love and desire in Alabama, Alaska, and Arizona.<br/>  <br/><i>Dangerous Masquerade</i>: Having spent her life in her cousin’s shadow, shy secretary Laurie Evans steps into the spotlight. She bears a strong resemblance to her movie-star cousin, LaRaine, and agrees to masquerade as the spoiled actress on a trip to Alabama to meet LaRaine’s future in-laws. But when her cousin’s fiancé, Rian Montgomery, arrives unexpectedly, Laurie can’t help but desire the millionaire hotel magnate—and a dazzling romance that’s no charade.<br/>  <br/><i>Northern Magic</i>: Shannon Hayes is thrilled to reunite with her fiancé, Rick, in Anchorage, Alaska, after a long separation, but when she arrives he’s disappeared. Desperate to find him, Shannon asks Rick’s employer, Cody, for help, and soon his comforting, reliable presence makes her wonder if she’s giving her heart to the wrong man.<br/>  <br/><i>Sonora Sundown</i>: Lost in the desert, Brandy Ames is alone, frightened, and desperate for help. She’s relieved when she stumbles upon the campfire of drop-dead gorgeous cattle thief Jim Corbett. Rugged and mysterious, Jim is a man of few words, but Brandy is happy to saddle up next to him and ride out a sandstorm that forces them to take shelter for the night—in each other’s arms.<br/>  <br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janet Dailey
      </h2>
      
      <p class="authorDescription body article">Janet Dailey, who passed away in 2013, was born Janet Haradon in 1944 in Storm Lake, Iowa. She attended secretarial school in Omaha, Nebraska, before meeting her husband, Bill. The two worked together in construction and land development until they &ldquo;retired&rdquo; to travel throughout the United States, inspiring Dailey to write the Americana series of romances, setting a novel in every state of the Union. In 1974, Dailey was the first American author to write for Harlequin. Her first novel was <I>No Quarter Asked</I>. She went&#160;on to write approximately ninety novels, twenty-one of which appeared on the <I>New York Times</I> bestseller list. She won many awards and accolades for her work, appearing widely on radio and television. Today, there are over three hundred million Janet Dailey books in print in nineteen different languages, making her one of the most popular novelists in the world. For more information about Dailey, visit www.janetdailey.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a3459956